export default function Features() {
  return (
    <>
      <section className="hero text-white">
        <div className="d-flex justify-content-between align-items-start flex-wrap gap-3">
          <div>
            <div className="badge-soft mb-2">Feature deep dive</div>
            <h1 className="display-6 fw-bold">Command the product signal mesh.</h1>
            <p className="lead">
              PulseFrame fuses telemetry, revenue, and sentiment into one cohesive layer—no spreadsheets,
              no lag.
            </p>
          </div>
          <div className="pill">
            <i className="bi bi-boxes"></i> Modular tiles · No-code
          </div>
        </div>
      </section>

      <section className="mt-5">
        <h2 className="section-title mb-3">Core capabilities</h2>
        <div className="bento-grid">
          <div className="glass-card">
            <div className="icon-chip mb-3">
              <i className="bi bi-diagram-3"></i>
            </div>
            <h5>Unified signal layer</h5>
            <p className="text-muted mb-2">
              Stream events from product, CRM, and support into a single real-time canvas.
            </p>
            <span className="pill">Latency &lt; 300ms</span>
          </div>
          <div className="glass-card">
            <div className="icon-chip mb-3">
              <i className="bi bi-magic"></i>
            </div>
            <h5>AI workbench</h5>
            <p className="text-muted mb-2">
              Generate briefs, QA scripts, and release notes tied to live metrics—no stale templates.
            </p>
            <span className="pill">Grounded outputs</span>
          </div>
          <div className="glass-card">
            <div className="icon-chip mb-3">
              <i className="bi bi-kanban"></i>
            </div>
            <h5>Bento layout engine</h5>
            <p className="text-muted mb-2">
              Arrange glass panels, neon chips, and focus cards to match your workflow.
            </p>
            <span className="pill">Drag, resize, pin</span>
          </div>
          <div className="glass-card">
            <div className="icon-chip mb-3">
              <i className="bi bi-shield-check"></i>
            </div>
            <h5>Enterprise trust</h5>
            <p className="text-muted mb-2">
              SSO, audit logs, DLP, and per-tenant encryption by default.
            </p>
            <span className="pill">SOC2 mapped</span>
          </div>
          <div className="glass-card">
            <div className="icon-chip mb-3">
              <i className="bi bi-bar-chart-line"></i>
            </div>
            <h5>Revenue-aware KPIs</h5>
            <p className="text-muted mb-2">
              Tie feature adoption to ARR, pipe coverage, and retention cohorts automatically.
            </p>
            <span className="pill">Cohorts auto-refresh</span>
          </div>
          <div className="glass-card">
            <div className="icon-chip mb-3">
              <i className="bi bi-broadcast"></i>
            </div>
            <h5>Alerts that matter</h5>
            <p className="text-muted mb-2">
              Adaptive thresholds trigger pings only when material changes occur—not for noise.
            </p>
            <span className="pill">Noise-cancelled</span>
          </div>
        </div>
      </section>

      <section className="mt-5">
        <div className="row g-3">
          <div className="col-lg-6">
            <div className="glass-card h-100">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="mb-0">Design language</h5>
                <span className="pill">
                  <i className="bi bi-palette2"></i> 2025 trends
                </span>
              </div>
              <p className="mb-2">
                Glassmorphic layers and monochrome minimalism keep contrast AA+ while matching 2025 bento
                layout trends.
              </p>
              <ul className="list-unstyled text-muted mb-0">
                <li className="mb-2">
                  <i className="bi bi-check-circle"></i> Gradient heroes with subtle grid overlays
                </li>
                <li className="mb-2">
                  <i className="bi bi-check-circle"></i> Hover lifts & glow cues for actionable tiles
                </li>
              </ul>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="glass-card h-100">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="mb-0">Implementation facts</h5>
                <span className="pill">
                  <i className="bi bi-braces"></i> Bootstrap 5.3
                </span>
              </div>
              <div className="table-shadow">
                <table className="table mb-0 align-middle">
                  <tbody>
                    <tr>
                      <th scope="row">Framework</th>
                      <td>React + React Router on Vite 6</td>
                    </tr>
                    <tr>
                      <th scope="row">Theme</th>
                      <td>Mono Minimal (fixed)</td>
                    </tr>
                    <tr>
                      <th scope="row">Routes</th>
                      <td>Home, Features, Pricing, About, Contact</td>
                    </tr>
                    <tr>
                      <th scope="row">Hosting</th>
                      <td>Static SPA via Cloudflare Workers</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
